import { render, staticRenderFns } from "./PriceDiscTable.vue?vue&type=template&id=6d5e580e"
import script from "./PriceDiscTable.vue?vue&type=script&lang=js"
export * from "./PriceDiscTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports